import { DuplicateWarnMessage } from 'src/@types/DuplicateWarnMessage';
import { DisclosureLevel } from 'src/constants';
import { SurveyFormData } from 'src/features/general/enquete-answer/store/enqueteAnswerSlice';
import { SurveyDetailEntity } from './useSurveyDetailApi';

type EnqueteSentStatus = 'SENT' | 'SENT_FAILED' | 'PROCESSING';

export interface SurveyDetailAction5Entity {
  id: string;
  version: number;
  surveyFormData?: SurveyFormData;
  surveyDetail?: SurveyDetailEntity;
  surveyDetailId: string;
  disclosureLevel?: DisclosureLevel | null;
  duplicateWarnMessage?: DuplicateWarnMessage | null;
  sentStatus?: EnqueteSentStatus | null;
  sentAt?: Date | null;
  createdBy: string;
  updatedBy: string;
  createdAt: Date | null;
  updatedAt: Date | null;
  isDeleted: boolean;
}

export const initSurveyDetailAction5: SurveyDetailAction5Entity = {
  id: '',
  version: 0,
  surveyDetailId: '',
  duplicateWarnMessage: null,
  createdBy: '',
  updatedBy: '',
  createdAt: new Date(),
  updatedAt: new Date(),
  isDeleted: false,
};

/**
 * SurveyDetail API
 *
 * @returns
 */
export const useSurveyDetailApi = () => {
  return {};
};
